
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`How can I override inline styles?`}</h2>
    <p>{`Inline styles will always take precedence over external CSS, so you cannot override it by simply increasing specificity.`}</p>
    <p>{`There is a neat trick however, which is to use the style `}<inlineCode parentName="p">{`element-attr`}</inlineCode>{` CSS Selector in conjunction with `}<inlineCode parentName="p">{`!important`}</inlineCode>{`:`}</p>
    <pre><code parentName="pre" {...{
        "className": "language-js"
      }}>{`const MyStyledComponent = styled(InlineStyledComponent)\`
  &[style] {
    font-size: 12px !important;
    color: blue !important;
  }
\`
`}</code></pre>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;